import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-list-editor',
    templateUrl: './custom-list-editor.component.html',
    styleUrls: ['./custom-list-editor.component.css'],
    standalone: false
})
export class CustomListEditorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
